import * as React from 'react'
import { forwardRef, useEffect, useState } from 'react'
import ClickToEdit from 'react-click-to-edit'

const roleMapping = {}

export const PrintContent = React.forwardRef<HTMLDivElement, any>(
  (props, ref) => {
    const { user, setEditMode } = props
    const { fullName, role, country, tickets } = user

    const renderField = (value, className = '') => (
      <ClickToEdit
        wrapperClass={`line ${className}`}
        initialValue={value}
        startEditing={() => {
          setEditMode(true)
        }}
        endEditing={() => {
          setEditMode(false)
        }}
      />
    )

    return (
      <div className="scan-tag">
        <div ref={ref} className={`print-container`}>
          <div className="print-text">
            {/* <div className="imageGap"></div> */}
            {renderField(fullName, 'fullName')}
            {renderField(country, 'country')}
            {renderField(role, 'role')}
            {renderField(tickets, 'tickets')}
          </div>
        </div>
      </div>
    )
  }
)

export default PrintContent
